import React from "react";

const Image = ({ image, alt }) => {
	return <img src={image} alt={alt} />;
};

export default Image;
